export const succesinactividad = {
    data: {
        message: "Inactividad OTP inquilino",
        leadId: "00Qdq000001hQ9xEAE",
        encryptedQuote: "1DM4tXxam7XGkjKRvN8RNrQ%2BnyvGBpe%2BPVCGmVS17fGXzJZR55yb0RLyjBo1dhW6"
    },
    error: false
}

export const succesinactividadriesgobajo = {
    data: {
        message: "Inactividad OTP inquilino",
        leadId: "00Qdq000001hQ9xEAE",
        encryptedQuote: "1DM4tXxam7XGkjKRvN8RNrQ%2BnyvGBpe%2BPVCGmVS17fGXzJZR55yb0RLyjBo1dhW6"
    },
    error: false
}

export const succesinactividadriesgomedio = {
    data: {
        message: "Inactividad OTP inquilino",
        leadId: "00Qdq000001hQ9xEAE",
        encryptedQuote: "1DM4tXxam7XGkjKRvN8RNrQ%2BnyvGBpe%2BPVCGmVS17fGXzJZR55yb0RLyjBo1dhW6"
    },
    error: false
}

